import React from "react";
import { PaymentHubAPI } from "../../../providers/PaymentHubAPI";
import { Button } from "../../components/Button";
import { Drawer } from "../../components/Drawer";
import { Input } from "../../components/Input";
import { Loading } from "../../components/Loading";
import { EnvironmentStorage } from "../../tools/EnvironmentStorage";
import { Select } from "../../components/Select";
import styles from "@styles/integrations.module.scss";
import { Context } from "pages/Integrations";
import { Checkbox } from "../../components/Checkbox";
import { EnvironmentsAPI } from "../../../providers/EnvironmentsAPI";
import { PaymentMethodConflictWarning } from "../../components/PaymentMethodConflictWarning";

export class SafraPayDrawer extends React.Component {

    state = {
        loading: false,
        savingOptions: false,
        localPaymentMethods: {},
        initialPaymentMethods: {},
        lastActivatedMethod: null
    }

    async setAsyncState(data) {
        return new Promise((resolve) => this.setState(data, resolve));
    }

    getDefaultWebhook () {
        const baseUrl = (process.env.REACT_APP_SERVICES_ENDPOINT_BASE).replace('{SERVICE}','orders');
        return `${baseUrl}/webhook/status`;
    }

    async componentDidMount() {
        try {
            await this.setAsyncState({ loading: true });
            const selectedEnvironment = await EnvironmentStorage.getSelectedEnvironment();
            await PaymentHubAPI.initAccount();
            const safraPayGateway = await PaymentHubAPI.getGatewayConfiguration(selectedEnvironment, `safrapay`);
            const paymenthub = await EnvironmentsAPI.getConfigurationsByAlias(selectedEnvironment, 'paymenthub');

            this.setState({
                environmentType: safraPayGateway.environmentType || "PRODUCTION",
                merchantId: safraPayGateway.merchantId,
                merchantDocument: safraPayGateway.merchantDocument,
                merchantToken: safraPayGateway.merchantToken,
                fingerprintId: safraPayGateway.fingerprintId,
                webhookUrl: safraPayGateway?.webhook?.url || this.getDefaultWebhook(),
                webhookMethod: safraPayGateway?.webhook?.method || "POST",
                clearSaleAppId: safraPayGateway?.clearSaleAppId,
                contingencyEmail: safraPayGateway?.contingencyEmail,
                localPaymentMethods: paymenthub?.paymentMethods || {},
                initialPaymentMethods: { ...(paymenthub?.paymentMethods || {}) }
            })

            await this.setAsyncState({ loading: false });
        } catch (err) {
            await this.setAsyncState({ loading: false });
        }
    }

    handlePaymentMethodCheckbox = (cat, checked) => {
        this.setState((prevState) => {
            const wasChecked = prevState.localPaymentMethods[cat] === "safrapay";
            const willBeChecked = checked;
            let lastActivatedMethod = null;
            if (!wasChecked && willBeChecked) {
                lastActivatedMethod = cat;
            }
            return {
                localPaymentMethods: {
                    ...prevState.localPaymentMethods,
                    [cat]: checked ? "safrapay" : ""
                },
                lastActivatedMethod
            };
        });
    }

    async onSave() {
        try {
            const { onSave } = this.props;
            const { environmentType, merchantId, merchantDocument, merchantToken, clearSaleAppId, contingencyEmail, webhookUrl, webhookMethod, localPaymentMethods } = this.state;
            await this.setAsyncState({ savingOptions: true });
            const selectedEnvironment = await EnvironmentStorage.getSelectedEnvironment();
            const paymenthub = await EnvironmentsAPI.getConfigurationsByAlias(selectedEnvironment, 'paymenthub');
            const currentPaymentMethods = paymenthub?.paymentMethods || {};
            const updatedPaymentMethods = { ...currentPaymentMethods };
            Object.keys(localPaymentMethods).forEach((cat) => {
                if (localPaymentMethods[cat] === "safrapay") {
                    updatedPaymentMethods[cat] = "safrapay";
                } else if (updatedPaymentMethods[cat] === "safrapay") {
                    delete updatedPaymentMethods[cat];
                }
            });
            paymenthub.paymentMethods = updatedPaymentMethods;
            await EnvironmentsAPI.putConfigurationsByAlias(selectedEnvironment, 'paymenthub', paymenthub);
            const body = {
                environmentType: environmentType,
                merchantId,
                merchantDocument,
                merchantToken,
                clearSaleAppId,
                contingencyEmail,
                webhook: {
                    url: webhookUrl,
                    method: webhookMethod
                },
                paymentMethods: updatedPaymentMethods
            };
            const response = await PaymentHubAPI.setGatewayConfiguration(selectedEnvironment, `safrapay`, body)
            await this.setAsyncState({ savingOptions: false });
            if (response.getErrors([]).length === 0) {
                onSave && onSave();
            } else {
                alert({ text: `Não foi possível salvar as credenciais: ${response.getErrors()[0]}` });
            }
        } catch (e) {
            await this.setAsyncState({ savingOptions: false });
        }
    }


    render() {
        const { visible, onClose } = this.props;
        const { environmentType, merchantId, merchantDocument, merchantToken, clearSaleAppId, contingencyEmail, savingOptions, loading, localPaymentMethods } = this.state;

        const SUPPORTED_CATEGORIES = ["PIX", "CREDIT", "DEBIT", "VOUCHER"];
        const CATEGORY_LABELS = {
            PIX: "Pix",
            CREDIT: "Crédito",
            DEBIT: "Débito",
            VOUCHER: "Voucher"
        };

        return (
            <Drawer
                visible={visible}
                onClose={onClose}
                closeInFade
                title={"Integração - SafraPay"}
                footer={
                    <Button
                        design="primary"
                        className="w-100"
                        onClick={this.onSave.bind(this)}
                        loading={savingOptions}
                        disabled={loading || savingOptions}
                    >
                        Salvar alterações
                    </Button>
                }
            >
                <Context />

                {loading ? (
                    <div className="d-flex justify-center align-center h-100">
                        <Loading fullScreen />
                    </div>
                ) : (
                    <div className={styles.scrollContainer}>
                        <Select
                            design="two"
                            label="Ambiente"
                            onChange={(e) => this.setState({ environmentType: e.target.value })}
                            className="mb-20"
                            value={environmentType}
                            options={[
                                { label: "Produção", value: "PRODUCTION", selected: environmentType === "PRODUCTION" },
                                { label: "Homologação", value: "SANDBOX", selected: environmentType === "SANDBOX" }
                            ]}
                        />
                        <Input
                            design="two"
                            className="mb-20"
                            floatLabel="Id da conta"
                            value={merchantId}
                            onChange={(e) => this.setState({ merchantId: e.target.value })}
                        />
                        <Input
                            design="two"
                            className="mb-20"
                            floatLabel="CNPJ"
                            value={merchantDocument}
                            onChange={(e) => this.setState({ merchantDocument: e.target.value.replace(/[^0-9]/g, '') })}
                        />
                        <Input
                            design="two"
                            className="mb-20"
                            floatLabel="Token"
                            value={merchantToken}
                            onChange={(e) => this.setState({ merchantToken: e.target.value })}
                        />
                        <Input
                            design="two"
                            className="mb-20"
                            floatLabel="Id aplicativo ClearSale"
                            value={clearSaleAppId}
                            onChange={(e) => this.setState({ clearSaleAppId: e.target.value })}
                        />
                        <Input
                            design="two"
                            className="mb-20"
                            floatLabel="E-mail de contingência"
                            value={contingencyEmail}
                            onChange={(e) => this.setState({ contingencyEmail: e.target.value })}
                        />
                          <p className={styles.subtitle}>
                                Métodos de pagamento disponíveis
                            </p>
                        <PaymentMethodConflictWarning
                            supportedCategories={SUPPORTED_CATEGORIES}
                            localPaymentMethods={localPaymentMethods}
                            initialPaymentMethods={this.state.initialPaymentMethods}
                            lastActivatedMethod={this.state.lastActivatedMethod}
                            categoryLabels={CATEGORY_LABELS}
                            integrationName="SafraPay"
                            gatewayName="safrapay"
                        />
                        {SUPPORTED_CATEGORIES.map((cat) => (
                            <div key={cat} className={styles.paymentMethodRow}>
                                <Checkbox
                                    checked={localPaymentMethods[cat] === "safrapay"}
                                    onChange={(checked) => this.handlePaymentMethodCheckbox(cat, checked)}
                                    label={CATEGORY_LABELS[cat]}
                                    name={`safrapay-method-${cat}`}
                                />
                            </div>
                        ))}
                    </div>
                )}
            </Drawer>
        )
    }
}
